import React, { Fragment } from 'react'
import { CssBaseline, Box } from '@material-ui/core'

import { usePageId } from '@seasonedsoftware/utils'
import PageTitle from 'core/PageTitle'

const Layout = props => {
  const { title, location, children, layoutStyle } = props
  const id = usePageId(location)

  return (
    <Fragment>
      <Box
        css={{
          width: '100%',
        }}
      >
        <Box
          component="section"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            ...layoutStyle,
          }}
          id={id}
        >
          <CssBaseline />
          {title && <PageTitle>{title}</PageTitle>}
          {children}
        </Box>
      </Box>
    </Fragment>
  )
}

export default Layout
